import { apiClient } from "../../../Utilities/apiClient";
import { SingleTrail } from "../../../Resources/Data/Trails";

export interface TrailsListParams {
  page?: number;
  pageSize?: number;
  name?: string;
  status?: string;
  cityIds?: number[];
  countryIds?: number[];
  sortBy?: string;
}

export interface TrailsListResponse {
  trails: SingleTrail[];
  count: number;
  totalPages: number;
}

export const trailService = {
  // Single trail operations
  getTrail: (id: string) => 
    apiClient.get(`/trails/details/${id}`),

  updateTrail: (id: string, data: Partial<SingleTrail>) => 
    apiClient.put(`/trails/${id}`, data),

  createTrail: (formData: FormData) => 
    apiClient.post('/trails', formData, {
      contentType: 'multipart/form-data'
    }),

  deleteTrail: (id: string | number) => 
    apiClient.delete(`/trails/${id}`),

  // Trail listing with pagination and filters
  getTrails: (params: TrailsListParams = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params.name) queryParams.append('name', params.name);
    if (params.status) queryParams.append('status', params.status);
    if (params.cityIds && params.cityIds.length > 0) queryParams.append('cityIds', params.cityIds.join(','));
    if (params.countryIds && params.countryIds.length > 0) queryParams.append('countryIds', params.countryIds.join(','));
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    
    return apiClient.get(`/trails?${queryParams.toString()}`);
  },

  // Trail status management
  activateTrail: (id: string | number) => 
    apiClient.put('/trails/activate', { id }),

  deactivateTrail: (id: string | number) => 
    apiClient.put('/trails/deactivate', { id }),

  updateTrailStatus: (id: string | number, status: string) => 
    apiClient.put(`/trails/${id}/status`, { status }),

  // Trail components
  getCities: () => 
    apiClient.get("/trails/locations/cities"),

  updateTrailStartingPoint: (id: string, data: { latitude: number; longitude: number }) => 
    apiClient.put(`/trails/starting-point/${id}`, data),

  updateTrailPath: (id: string, data: { trail_path: number[][] }) => 
    apiClient.put(`/trails/trail-path/${id}`, data),

  updateTrailPhotos: (id: string, formData: FormData) => 
    apiClient.put(`/trails/${id}`, formData, {
      contentType: 'multipart/form-data'
    }),

  deleteTrailPhoto: (trailId: string, photoName: string) => 
    apiClient.delete(`/trails/${trailId}/photo/${photoName}`)
}; 